/*
PROV: COHINT001.BF.4GHKGAZHY9
REQ: SYS-ARCH-15
WHY: Next.js page module.
*/

import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { Toaster } from "sonner";

import { ErrorBoundary } from "../components/ErrorBoundary";
import { ConsentManager } from "../components/ConsentManager";
import "../styles/globals.css";
import "../styles/content-renderer.css";
import "@cohorta/ui/tokens.css";
import "@cohorta/ui/editor/styles";
import { installBrowserErrorReporter } from "@cohorta/shared/telemetry/browserErrorReporter";
import { installNextRouteTimingReporter, reportWebVital } from "@cohorta/shared/telemetry/rum";
import { evaluateAnalyticsGate, trackPageView } from "../lib/gaAnalytics";
import { onConsentChange } from "../lib/consent";

export default function App({ Component, pageProps }) {
  const router = useRouter();

  useEffect(() => {
    const uninstallErrors = installBrowserErrorReporter({ app: "admin" });
    const uninstallRum = installNextRouteTimingReporter(router, { app: "admin" });
    return () => {
      uninstallRum();
      uninstallErrors();
    };
  }, [router]);

  useEffect(() => {
    // ADR-007 loader gate: gtag is injected here at runtime, never from
    // _document.jsx, so no GA4 call fires before analytics consent is granted
    // (cohorta#439 contract). Dormant until that banner ships.
    evaluateAnalyticsGate();
    const unsubscribe = onConsentChange(evaluateAnalyticsGate);

    const handleRouteChange = (url) => trackPageView(url);
    router.events.on("routeChangeComplete", handleRouteChange);

    return () => {
      unsubscribe();
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);
  return (
    <ErrorBoundary>
      <Component {...pageProps} />
      <ConsentManager />
      <Toaster position="top-right" richColors closeButton />
    </ErrorBoundary>
  );
}

export function reportWebVitals(metric) {
  void reportWebVital(metric, { app: "admin" });
}
